import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['overlay', 'dialogContainer', 'dialog', 'header', 'closeButton', 'body', 'footer'];
var baseStyleOverlay = {
  bg: 'rgba(0, 0, 0, .7)',
  zIndex: 'modal',
  transition: 'background-color .6s ease',
  transitionProperty: 'background-color',
  transitionTimingFunction: 'ease-in-out',
  transitionDuration: '.15s'
};
function baseStyleDialogContainer(props) {
  var {
    isCentered,
    scrollBehavior
  } = props;
  return {
    display: 'flex',
    zIndex: 'modal',
    justifyContent: 'center',
    alignItems: isCentered ? 'center' : 'flex-start',
    overflow: scrollBehavior === 'inside' ? 'hidden' : 'auto'
  };
}
function baseStyleDialog(props) {
  var {
    scrollBehavior
  } = props;
  return {
    borderRadius: 'md',
    bg: 'white',
    color: 'inherit',
    my: '3.75rem',
    zIndex: 'modal',
    maxH: scrollBehavior === 'inside' ? 'calc(100vh - 7.5rem)' : undefined,
    boxShadow: 'lg'
  };
}
var baseStyleHeader = {
  display: 'flex',
  px: {
    base: 5,
    md: 8
  },
  py: 5,
  borderBottom: '1px',
  borderColor: {
    base: 'blue.600',
    md: '#E5E5E5'
  },
  fontSize: {
    base: 'md',
    md: 'lg'
  },
  fontWeight: 'bold',
  alignItems: 'center'
};
var baseStyleCloseButton = {
  ml: 'auto',
  alignSelf: 'flex-start',
  color: 'black',
  px: 2,
  fontSize: 'sm',
  svg: {
    flexShrink: 0,
    color: 'blue.600'
  }
};
function baseStyleBody(props) {
  var {
    scrollBehavior
  } = props;
  return {
    px: {
      base: 5,
      md: 8
    },
    py: 6,
    flex: 1,
    a: {
      color: 'blue.600',
      _hover: {
        textDecoration: 'underline'
      }
    },
    overflow: scrollBehavior === 'inside' ? 'auto' : undefined
  };
}
var baseStyleFooter = {
  borderTop: '1px',
  borderColor: '#E5E5E5',
  px: {
    base: 5,
    md: 8
  },
  py: {
    base: 10,
    md: 8
  },
  justifyContent: 'flex-end'
};
var baseStyle = props => ({
  overlay: baseStyleOverlay,
  dialogContainer: baseStyleDialogContainer(props),
  dialog: baseStyleDialog(props),
  header: baseStyleHeader,
  closeButton: baseStyleCloseButton,
  body: baseStyleBody(props),
  footer: baseStyleFooter
});

/**
 * Since the `maxWidth` prop references theme.sizes internally,
 * we can leverage that to size our modals.
 */
function getSize(value) {
  if (value === 'full') {
    return {
      dialog: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        borderRadius: 'none',
        maxW: '100vw',
        maxH: '100vh',
        h: 'calc(100vh - calc(100vh - 100%))',
        m: 0
      }
    };
  }
  return {
    dialog: {
      maxW: value
    }
  };
}
var sizes = {
  xs: getSize('xs'),
  sm: getSize('sm'),
  md: getSize('md'),
  lg: getSize('lg'),
  xl: getSize('xl'),
  '2xl': getSize('2xl'),
  '3xl': getSize('3xl'),
  '4xl': getSize('4xl'),
  '5xl': getSize('5xl'),
  '6xl': getSize('6xl'),
  full: getSize('full')
};
var defaultProps = {
  size: '3xl'
};
export default asMultiStyleConfig({
  parts,
  baseStyle,
  sizes,
  defaultProps
});